/** True when the flash was created within the last `days` days (inclusive of today). */
export function isNewFlashByCreatedAt(createdAt: unknown, days = 10): boolean {
  if (createdAt == null) return false

  const createdRaw = createdAt as unknown
  const createdAtDate =
    createdRaw instanceof Date
      ? createdRaw
      : typeof createdRaw === 'object' &&
          createdRaw !== null &&
          'toDate' in createdRaw &&
          typeof (createdRaw as { toDate: () => Date }).toDate === 'function'
        ? (createdRaw as { toDate: () => Date }).toDate()
        : new Date(createdRaw as string | number)

  if (Number.isNaN(createdAtDate.getTime())) return false

  const now = new Date()
  const cutoff = new Date(now)
  cutoff.setDate(now.getDate() - days)

  return createdAtDate >= cutoff && createdAtDate <= now
}
